import { readableColor } from "polished";
import get from "lodash.get";

/* eslint-disable sort-keys */
export default {
    Box: {
        baseStyle: ({ theme: { colors }, background, bg }) => ({
            fontFamily: "Body",
            color: get(colors, background || bg) ? readableColor(get(colors, background || bg), colors.white, colors.black) : "current"
        }),
        variants: {
            pulloutText: {
                bgColor:"secondary.50",
                p:"6",
                borderRadius:"5",
                border:"1px solid",
                mt:"s-4",
                borderColor:"accent1.100",
                boxShadow:"0 0.75rem 1.5rem rgb(18 38 63 / 3%)",
            }
        }
    }
};
